import { FaClipboardList, FaPlus, FaCalendarAlt, FaUsers, FaSearch } from "react-icons/fa";
import { useState } from "react";

export default function MeetingMinutes() {
  const [minutes, setMinutes] = useState([
    {
      id: 1,
      meetingTitle: "Monthly Council Meeting - January",
      date: "2025-01-15",
      attendees: ["Sarah Johnson", "Michael Chen", "Emily Rodriguez", "David Kim", "Lisa Anderson"],
      facilitator: "Sarah Johnson",
      notes: [
        { topic: "Budget Review", content: "Discussed Q1 budget allocation. Motion to approve passed 4-1." },
        { topic: "Event Planning", content: "Staff appreciation event scheduled for March 22. Emily will lead planning committee." },
        { topic: "Policy Updates", content: "New remote work policy proposed. Will be voted on next meeting." },
      ],
      actionItems: [
        { task: "Finalize event budget", assignee: "Emily Rodriguez", dueDate: "2025-01-22" },
        { task: "Draft remote work policy document", assignee: "Michael Chen", dueDate: "2025-01-29" },
      ],
      decisions: [
        "Approved Q1 budget allocation",
        "Set staff appreciation event date for March 22",
      ],
    },
    {
      id: 2,
      meetingTitle: "Special Budget Meeting",
      date: "2025-01-08",
      attendees: ["Sarah Johnson", "David Kim", "Michael Chen", "James Wilson"],
      facilitator: "David Kim",
      notes: [
        { topic: "Budget Priorities", content: "Discussed priorities for 2025 budget. Focus on professional development and wellness programs." },
        { topic: "Funding Requests", content: "Reviewed funding requests from various departments." },
      ],
      actionItems: [
        { task: "Compile budget recommendations", assignee: "David Kim", dueDate: "2025-01-12" },
      ],
      decisions: [
        "Prioritize professional development funding",
        "Increase wellness program budget by 15%",
      ],
    },
    {
      id: 3,
      meetingTitle: "Monthly Council Meeting - December",
      date: "2024-12-15",
      attendees: ["Sarah Johnson", "Michael Chen", "Emily Rodriguez", "David Kim", "Maria Garcia", "Lisa Anderson"],
      facilitator: "Sarah Johnson",
      notes: [
        { topic: "Year-End Review", content: "Reviewed accomplishments for 2024. Council successfully completed 12 major initiatives." },
        { topic: "Holiday Schedule", content: "Confirmed meeting schedule for January." },
        { topic: "Committee Reports", content: "All committees provided year-end reports." },
      ],
      actionItems: [
        { task: "Prepare annual report", assignee: "Michael Chen", dueDate: "2024-12-31", completed: true },
        { task: "Send holiday greetings to staff", assignee: "Sarah Johnson", dueDate: "2024-12-20", completed: true },
      ],
      decisions: [
        "Approved 2025 meeting schedule",
        "Recognized outstanding committee contributions",
      ],
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [newMinute, setNewMinute] = useState({
    meetingTitle: "",
    date: "",
    attendees: [],
    facilitator: "",
    notes: [{ topic: "", content: "" }],
    actionItems: [{ task: "", assignee: "", dueDate: "" }],
    decisions: [""],
  });
  const [attendeeInput, setAttendeeInput] = useState("");

  const filteredMinutes = minutes.filter(
    (minute) =>
      minute.meetingTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
      minute.notes.some((note) =>
        note.topic.toLowerCase().includes(searchTerm.toLowerCase()) ||
        note.content.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  const addNote = () => {
    setNewMinute({
      ...newMinute,
      notes: [...newMinute.notes, { topic: "", content: "" }],
    });
  };

  const updateNote = (index, field, value) => {
    const updatedNotes = [...newMinute.notes];
    updatedNotes[index][field] = value;
    setNewMinute({ ...newMinute, notes: updatedNotes });
  };

  const removeNote = (index) => {
    const updatedNotes = newMinute.notes.filter((_, i) => i !== index);
    setNewMinute({ ...newMinute, notes: updatedNotes });
  };

  const addActionItem = () => {
    setNewMinute({
      ...newMinute,
      actionItems: [...newMinute.actionItems, { task: "", assignee: "", dueDate: "" }],
    });
  };

  const updateActionItem = (index, field, value) => {
    const updatedItems = [...newMinute.actionItems];
    updatedItems[index][field] = value;
    setNewMinute({ ...newMinute, actionItems: updatedItems });
  };

  const removeActionItem = (index) => {
    const updatedItems = newMinute.actionItems.filter((_, i) => i !== index);
    setNewMinute({ ...newMinute, actionItems: updatedItems });
  };

  const addDecision = () => {
    setNewMinute({
      ...newMinute,
      decisions: [...newMinute.decisions, ""],
    });
  };

  const updateDecision = (index, value) => {
    const updatedDecisions = [...newMinute.decisions];
    updatedDecisions[index] = value;
    setNewMinute({ ...newMinute, decisions: updatedDecisions });
  };

  const removeDecision = (index) => {
    const updatedDecisions = newMinute.decisions.filter((_, i) => i !== index);
    setNewMinute({ ...newMinute, decisions: updatedDecisions });
  };

  const addAttendee = () => {
    if (attendeeInput.trim()) {
      setNewMinute({
        ...newMinute,
        attendees: [...newMinute.attendees, attendeeInput.trim()],
      });
      setAttendeeInput("");
    }
  };

  const removeAttendee = (index) => {
    const updatedAttendees = newMinute.attendees.filter((_, i) => i !== index);
    setNewMinute({ ...newMinute, attendees: updatedAttendees });
  };

  const saveMinutes = () => {
    if (!newMinute.meetingTitle || !newMinute.date || !newMinute.facilitator) {
      alert("Please fill in meeting title, date, and facilitator");
      return;
    }

    const minuteToSave = {
      id: Date.now(),
      ...newMinute,
      notes: newMinute.notes.filter(n => n.topic && n.content),
      actionItems: newMinute.actionItems.filter(a => a.task && a.assignee && a.dueDate),
      decisions: newMinute.decisions.filter(d => d.trim()),
    };

    setMinutes([minuteToSave, ...minutes]);
    setShowAddForm(false);
    setNewMinute({
      meetingTitle: "",
      date: "",
      attendees: [],
      facilitator: "",
      notes: [{ topic: "", content: "" }],
      actionItems: [{ task: "", assignee: "", dueDate: "" }],
      decisions: [""],
    });
  };

  const cancelAddForm = () => {
    setShowAddForm(false);
    setNewMinute({
      meetingTitle: "",
      date: "",
      attendees: [],
      facilitator: "",
      notes: [{ topic: "", content: "" }],
      actionItems: [{ task: "", assignee: "", dueDate: "" }],
      decisions: [""],
    });
  };

  const MinuteCard = ({ minute }) => (
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "28px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          marginBottom: "20px",
          paddingBottom: "20px",
          borderBottom: "2px solid #f7fafc",
        }}
      >
        <h3
          style={{
            fontSize: "22px",
            fontWeight: "600",
            color: "#2d3748",
            margin: "0 0 12px 0",
          }}
        >
          {minute.meetingTitle}
        </h3>
        <div
          style={{
            display: "flex",
            gap: "24px",
            fontSize: "14px",
            color: "#718096",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <FaCalendarAlt />
            <span>{new Date(minute.date).toLocaleDateString("en-US", { 
              month: "long", 
              day: "numeric", 
              year: "numeric" 
            })}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <FaUsers />
            <span>{minute.attendees.length} attendees</span>
          </div>
          <div>
            <strong>Facilitator:</strong> {minute.facilitator}
          </div>
        </div>
      </div>

      {/* Attendees */}
      <div style={{ marginBottom: "24px" }}>
        <h4
          style={{
            fontSize: "15px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "10px",
          }}
        >
          Attendees
        </h4>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {minute.attendees.map((attendee, index) => (
            <span
              key={index}
              style={{
                padding: "4px 10px",
                background: "#f7fafc",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "13px",
                color: "#4a5568",
              }}
            >
              {attendee}
            </span>
          ))}
        </div>
      </div>

      {/* Discussion Notes */}
      <div style={{ marginBottom: "24px" }}>
        <h4
          style={{
            fontSize: "15px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "12px",
          }}
        >
          Discussion Notes
        </h4>
        {minute.notes.map((note, index) => (
          <div
            key={index}
            style={{
              padding: "14px",
              background: "#f7fafc",
              borderRadius: "8px",
              marginBottom: "10px",
              borderLeft: "4px solid #667eea",
            }}
          >
            <div
              style={{
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "6px",
                fontSize: "14px",
              }}
            >
              {note.topic}
            </div>
            <div
              style={{
                color: "#4a5568",
                fontSize: "14px",
                lineHeight: "1.6",
              }}
            >
              {note.content}
            </div>
          </div>
        ))}
      </div>

      {/* Decisions */}
      {minute.decisions && minute.decisions.length > 0 && (
        <div style={{ marginBottom: "24px" }}>
          <h4
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "12px",
            }}
          >
            Decisions Made
          </h4>
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {minute.decisions.map((decision, index) => (
              <li
                key={index}
                style={{
                  color: "#4a5568",
                  fontSize: "14px",
                  marginBottom: "8px",
                  lineHeight: "1.6",
                }}
              >
                {decision}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Action Items */}
      {minute.actionItems && minute.actionItems.length > 0 && (
        <div>
          <h4
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "12px",
            }}
          >
            Action Items
          </h4>
          {minute.actionItems.map((item, index) => (
            <div
              key={index}
              style={{
                padding: "12px 14px",
                background: item.completed ? "#e6f7ee" : "#fef5e7",
                borderRadius: "8px",
                marginBottom: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontWeight: "500",
                    color: "#2d3748",
                    marginBottom: "4px",
                    fontSize: "14px",
                    textDecoration: item.completed ? "line-through" : "none",
                  }}
                >
                  {item.task}
                </div>
                <div style={{ fontSize: "13px", color: "#718096" }}>
                  <strong>Assignee:</strong> {item.assignee} | <strong>Due:</strong>{" "}
                  {new Date(item.dueDate).toLocaleDateString()}
                </div>
              </div>
              {item.completed && (
                <span
                  style={{
                    padding: "2px 8px",
                    background: "#38a169",
                    color: "white",
                    borderRadius: "4px",
                    fontSize: "11px",
                    fontWeight: "600",
                  }}
                >
                  COMPLETED
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
            }}
          >
            Meeting Minutes
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            View past meeting minutes and notes
          </p>
        </div>
        <button
          onClick={() => setShowAddForm(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
          }}
        >
          <FaPlus />
          Add Minutes
        </button>
      </div>

      {/* Add Minutes Form */}
      {showAddForm && (
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "32px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            border: "2px solid #667eea",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "24px",
            }}
          >
            Add New Meeting Minutes
          </h2>

          {/* Basic Info */}
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              Meeting Title *
            </label>
            <input
              type="text"
              value={newMinute.meetingTitle}
              onChange={(e) => setNewMinute({ ...newMinute, meetingTitle: e.target.value })}
              placeholder="e.g., Monthly Council Meeting - February"
              style={{
                width: "100%",
                padding: "12px 14px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                fontSize: "15px",
                outline: "none",
              }}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              marginBottom: "24px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#2d3748",
                  marginBottom: "8px",
                }}
              >
                Meeting Date *
              </label>
              <input
                type="date"
                value={newMinute.date}
                onChange={(e) => setNewMinute({ ...newMinute, date: e.target.value })}
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#2d3748",
                  marginBottom: "8px",
                }}
              >
                Facilitator *
              </label>
              <input
                type="text"
                value={newMinute.facilitator}
                onChange={(e) => setNewMinute({ ...newMinute, facilitator: e.target.value })}
                placeholder="Name of meeting facilitator"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {/* Attendees */}
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              Attendees
            </label>
            <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
              <input
                type="text"
                value={attendeeInput}
                onChange={(e) => setAttendeeInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && addAttendee()}
                placeholder="Enter attendee name and press Enter"
                style={{
                  flex: 1,
                  padding: "10px 14px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                }}
              />
              <button
                onClick={addAttendee}
                style={{
                  padding: "10px 20px",
                  background: "#667eea",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Add
              </button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {newMinute.attendees.map((attendee, index) => (
                <span
                  key={index}
                  style={{
                    padding: "6px 12px",
                    background: "#f7fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "6px",
                    fontSize: "13px",
                    color: "#4a5568",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {attendee}
                  <button
                    onClick={() => removeAttendee(index)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#e53e3e",
                      cursor: "pointer",
                      fontSize: "16px",
                      padding: 0,
                      lineHeight: 1,
                    }}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </div>

          {/* Discussion Notes */}
          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                Discussion Notes
              </label>
              <button
                onClick={addNote}
                style={{
                  padding: "6px 12px",
                  background: "#667eea",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                + Add Note
              </button>
            </div>
            {newMinute.notes.map((note, index) => (
              <div
                key={index}
                style={{
                  padding: "16px",
                  background: "#f7fafc",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                  <input
                    type="text"
                    value={note.topic}
                    onChange={(e) => updateNote(index, "topic", e.target.value)}
                    placeholder="Topic"
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "600",
                      marginRight: "8px",
                      outline: "none",
                    }}
                  />
                  <button
                    onClick={() => removeNote(index)}
                    style={{
                      padding: "8px 12px",
                      background: "#e53e3e",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
                <textarea
                  value={note.content}
                  onChange={(e) => updateNote(index, "content", e.target.value)}
                  placeholder="Note content..."
                  rows="3"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "6px",
                    fontSize: "14px",
                    resize: "vertical",
                    outline: "none",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Decisions */}
          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                Decisions Made
              </label>
              <button
                onClick={addDecision}
                style={{
                  padding: "6px 12px",
                  background: "#667eea",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                + Add Decision
              </button>
            </div>
            {newMinute.decisions.map((decision, index) => (
              <div key={index} style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <input
                  type="text"
                  value={decision}
                  onChange={(e) => updateDecision(index, e.target.value)}
                  placeholder="Decision made..."
                  style={{
                    flex: 1,
                    padding: "10px 14px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
                <button
                  onClick={() => removeDecision(index)}
                  style={{
                    padding: "10px 16px",
                    background: "#e53e3e",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "12px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          {/* Action Items */}
          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                Action Items
              </label>
              <button
                onClick={addActionItem}
                style={{
                  padding: "6px 12px",
                  background: "#667eea",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                + Add Action Item
              </button>
            </div>
            {newMinute.actionItems.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: "16px",
                  background: "#fef5e7",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  border: "1px solid #f9d67a",
                }}
              >
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
                  <button
                    onClick={() => removeActionItem(index)}
                    style={{
                      padding: "6px 12px",
                      background: "#e53e3e",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      fontSize: "11px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
                <input
                  type="text"
                  value={item.task}
                  onChange={(e) => updateActionItem(index, "task", e.target.value)}
                  placeholder="Task description"
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    marginBottom: "10px",
                    outline: "none",
                  }}
                />
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                  <input
                    type="text"
                    value={item.assignee}
                    onChange={(e) => updateActionItem(index, "assignee", e.target.value)}
                    placeholder="Assignee"
                    style={{
                      padding: "10px 14px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  <input
                    type="date"
                    value={item.dueDate}
                    onChange={(e) => updateActionItem(index, "dueDate", e.target.value)}
                    style={{
                      padding: "10px 14px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Form Actions */}
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <button
              onClick={cancelAddForm}
              style={{
                padding: "12px 24px",
                background: "#e2e8f0",
                color: "#2d3748",
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={saveMinutes}
              style={{
                padding: "12px 24px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
              }}
            >
              Save Minutes
            </button>
          </div>
        </div>
      )}

      {/* Search Bar */}
      <div
        style={{
          marginBottom: "30px",
          background: "white",
          padding: "16px",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <FaSearch style={{ color: "#718096", fontSize: "18px" }} />
        <input
          type="text"
          placeholder="Search meeting minutes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            fontSize: "15px",
            color: "#2d3748",
          }}
        />
      </div>

      {/* Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#667eea" }}>
            {filteredMinutes.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Meeting Records
          </div>
        </div>
      </div>

      {/* Minutes List */}
      <div>
        {filteredMinutes.length > 0 ? (
          filteredMinutes.map((minute) => <MinuteCard key={minute.id} minute={minute} />)
        ) : (
          <div
            style={{
              padding: "60px",
              textAlign: "center",
              background: "white",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
            }}
          >
            <FaClipboardList
              style={{ fontSize: "48px", color: "#cbd5e0", marginBottom: "16px" }}
            />
            <p style={{ color: "#718096", fontSize: "16px" }}>
              No meeting minutes found
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

